import { getState } from '~src/state';
import { exportIMG } from '~core';
import { getMultiplier } from '~src/utils';

// imgData è l'immagine di stampa della pagina (PDF, JPEG, PNG, provini). Per
// la pagina aperta costa un'esportazione a piena risoluzione, quindi si genera
// solo prima di lasciarla e prima di un'esportazione. imgDataDirty dice se il
// canvas è stato ridisegnato dopo l'ultima generazione: solo false garantisce
// che imgData sia aggiornata.

export class PageImageError extends Error {
  constructor(cause) {
    super(
      `Non è stato possibile preparare l'immagine della pagina aperta: ${cause.message}`
    );
    this.name = 'PageImageError';
    this.cause = cause;
  }
}

export const getCurrentPage = () => {
  const pages = getState('pages') || [];
  return pages[getState('currentPageIndex') || 0];
};

export const isCurrentPage = (page) =>
  Boolean(page) && page === getCurrentPage();

export const markCurrentPageImageDirty = () => {
  const page = getCurrentPage();
  if (page) {
    page.imgDataDirty = true;
  }
};

export const ensureCurrentPageImage = () => {
  const page = getCurrentPage();
  if (!page) {
    throw new Error('Current page is missing');
  }

  if (page.imgData && page.imgDataDirty === false) {
    return page.imgData;
  }

  const canvas = window.canvas;
  if (!canvas || typeof canvas.toDataURL !== 'function') {
    page.imgDataDirty = true;
    throw new Error('Canvas is not ready');
  }

  try {
    const project = getState('selected.tipo');
    const { base64 } = exportIMG(
      0.92,
      project.outputDpi,
      'base64',
      'jpeg',
      true,
      getMultiplier()
    );
    page.imgData = base64;
    page.imgDataDirty = false;
    return base64;
  } catch (error) {
    page.imgDataDirty = true;
    throw error;
  }
};
